<script setup lang="ts">
import type { PublicMediaAsset } from '~/modules/public/purchase/domain/public-purchase.types'
import { publicImageAttributes, publicImageAvifSource } from '~/modules/public/purchase/presentation/media/public-image'

// Attributes, classes and listeners belong to the <img>; <picture> only adds the AVIF source.
defineOptions({ inheritAttrs: false })
const props = defineProps<{
  image: Pick<PublicMediaAsset, 'contentPath'>
  sizes: string
}>()
const attrs = useAttrs()
const fallback = computed(() => publicImageAttributes(props.image, props.sizes))
const avif = computed(() => publicImageAvifSource(props.image, props.sizes))
</script>

<template>
  <picture>
    <source
      v-if="avif"
      :type="avif.type"
      :srcset="avif.srcset"
      :sizes="avif.sizes"
    >
    <img v-bind="{ ...fallback, ...attrs }">
  </picture>
</template>

<style scoped>
picture {
  display: contents;
}
</style>
